import type { Dossier } from '@wizbii/utils/models';

import { createReducer, on } from '@ngrx/store';
import { DossierGetSuccess } from '@stores/dossier/dossier-ngrx.action';

export const dossiersKey = 'dossier';

export type DossiersState = { dossiers: Dossier[] | undefined };

const initialState: DossiersState = { dossiers: undefined };

export const dossierReducer = createReducer(
  initialState,
  on(DossierGetSuccess, (_, { dossiers }) => {
    return { dossiers };
  })
);
